import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { DefaultCard } from "../../assets/styled-components/card";
import { ErrorChips, SuccessChips } from "../../assets/styled-components/chips";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import utils from "../../utility/utilities";
import CloseButton from "../commoncomponents/CloseButton";
import CreateNewButton from "../commoncomponents/CreateNewButton";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import PageTitle from "../commoncomponents/PageTitle";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import SectionTitle from "../commoncomponents/SectionTitle";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import { useDispatch } from "react-redux";
import PageLoader from "../commoncomponents/PageLoader";
import { updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import commonMessages from "../../utility/constant";


const Departmentworkrequestlist = () => {
  const [rows, setRows] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [gridApi, setGridApi] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const facilityid = getFacilityId("");
  const [isLoading, setIsLoading] = useState(false);
  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0)
  const [pageLoading, setPageLoading] = useState(false)
  const [verificationDialogOpen, setVerificationDialogOpen] = useState(false); // DeptUser - pending work order verification
  const serviceOptions = [
    { label: "FEMS", value: "FEMS", id: 1 },
    { label: "BEMS", value: "BEMS", id: 2 },
  ];
  const [service, setService] = useState(serviceOptions[0]);

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGT010");
  const accessWO = utilities.getScreenPermissions(accessData, "ENGT001");
  const dispatch = useDispatch();
  const roleName = localStorage.getItem('roleName');
  const deptAccess = roleName === 'DeptUser' ? true : false;

  const handleLinkClick = (deptid) => (event) => {
    event.preventDefault(); // Prevent default link navigation

    // Dispatch any action you need
    dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
    dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }))
    const title = `Create Unscheduled Work Order`;
    const deptData = {
      ...deptid, assetno: { label: deptid.assetno, value: deptid.assetId },
      categoryId: { label: deptid.categoryName, value: deptid.categoryId },
      typeId: { label: deptid.type, value: deptid.typeId },
    }
    // Navigate with state parameters
    navigate("/workorder/register", { state: { title, deptid: deptData,isCreateMode:true } } );
    // navigate("/workorder/register", { state: { title, deptid: deptData,isCreateMode:true, year: year?.value,
    //   month: { value: month?.value, label: month?.label, id: month?.id } } },
    // );

  };
  const columns = [
    {
      field: "deptworkrequestno",
      headerName: "Work Request No.",
      width: 180,
      cellRenderer: (params) => {
        const { status, workorderNo } = params.data;

        if (status === "Open" && localStorage.getItem("roleName") !== "DeptUser" && workorderNo === "" && accessWO?.canCreate) {
          return (
            <a
              href="/workorder/register" // Placeholder href for accessibility
              onClick={handleLinkClick(params?.data)}
              style={{ textDecoration: 'underline', color: '#1a73e8' }}
            >
              {params.value}
            </a>
          );
        }
        return params.value; // Plain text if status is not 'Open'
      },
    },
    {
      field: "workorderNo",
      headerName: "Work Order No.",
      width: 150
    },
    ...(roleName === "DeptUser"
      ? [
          {
            field: "departmentname",
            headerName: "Department Description",
            width: 150,
          },
        ]
      : []),
    {
      field: "deptWorkRequestDateFormate",
      headerName: "Work Request Date",
      width: 150,
      comparator: utils.dateComparator.bind(utils),
    },
    { field: "type", headerName: "Work Request Type", width: 180 },
    {
      field: "requestdetails",
      headerName: "Work Request Description",
      width: 150,
    },
    {
      field: "service",
      headerName: "Service",
      width: 150,
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      cellRenderer: (params) => {
        if (params.value === "Open" || params.value === "Cancelled") {
          return <ErrorChips label={params.value} />;
        }
        if (params.value === "Closed" ) {
          return <SuccessChips label={params.value} />;
        }
        return null;
      },
    },
   
  ];


  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);
  const [monthsOptions, setMonthsOptions] = useState([]);
  const allMonths = commonMessages.months;
  const currentYear = new Date().getFullYear();

  const yearsOptions = Array.from(
    { length: currentYear - 2016 + 1 },
    (_, i) => ({
      label: (2016 + i).toString(),
      value: (2016 + i).toString(),
    })
  );

  // Initial load: Set the year and limit months to current month
  useEffect(() => {
    const currentMonthIndex = new Date().getMonth();
    setYear({ label: currentYear.toString(), value: currentYear.toString() });
    setMonthsOptions([...allMonths.slice(0, currentMonthIndex + 1)]); // Up to current month on initial load
    setMonth(allMonths[currentMonthIndex]); // Set default to current month on initial load only
  }, []);

  const handleYearChange = (newValue) => {
    if (newValue && newValue?.value !== year?.value) {
      setYear(newValue);
      const selectedYear = parseInt(newValue.value);

      // Determine months to show based on selected year
      const months = selectedYear === currentYear
        ? allMonths.slice(0, new Date().getMonth() + 1) // Up to current month for the current year
        : allMonths; // Full year for any other year

      setMonthsOptions([...months]);
      setMonth(allMonths[0]); // Default to the first month (January)
    }
  };

  const handleMonthChange = (newValue) => {
    setMonth(newValue);
  };



  useEffect(() => {
    if (year && month) {
      fetchUserDepartments();
    }
  }, [year, month]);

  // const handleServiceChange = (newValue) => {
  //   setService(newValue);
  //   setPageIndex(1);
  //   setPageSize(10);
  //   setFilterModel([])
  //   setSortModel([]);

  //   // Set the current year and current month when service changes
  //   const currentYearValue = { label: currentYear.toString(), value: currentYear.toString() };
  //   const currentMonthIndex = new Date().getMonth();
  //   const currentMonthValue = allMonths[currentMonthIndex];

  //   setYear(currentYearValue);
  //   setMonthsOptions([...allMonths.slice(0, currentMonthIndex + 1)]); // Up to current month for the current year
  //   setMonth(currentMonthValue); // Set default to current month

  // };

  const fetchUserDepartments = async () => {
    setRows([]);
    setIsLoading(true);

    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1 : 0;
      var userid = localStorage.getItem("UserId");

      // Fetch data from both endpoints concurrently
      const [femResponse, bemResponse] = await Promise.all([
        axios.get(
          `${FemsGraph}/api/GraphfemDepartmentrequest/Getfemsworkrequestlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
          config
        ),
        axios.get(
          `${BemsGraph}/api/GraphbemDepartmentrequest/Getbemsworkrequestlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
          config
        ),
      ]);

      
      // Combine data from both responses
      const combinedData = [
        ...femResponse.data.items,
        ...bemResponse.data.items,
      ];

      // Format the combined data
      const formattedData = combinedData.map((item) => ({
        ...item,
        // Add any additional formatting here if needed
      }));

      setRows(formattedData);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setIsLoading(false);
    }
  };


  // const fetchExportdata = async () => {
  //   setPageLoading(true)
  //   try {
  //     const token = getAuthToken("id_token");
  //     const config = {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     };

  //     let response;
  //     if (service.value === "FEMS") {
  //       response = await axios.get(
  //         `${FemsGraph}/api/GraphfemDepartmentrequest/GetWorkRequestExport/${facilityid}/${year.value}/${month.id}?filterOptions=${JSON.stringify(
  //           filterModel
  //         )}&sortOptions=${JSON.stringify(sortModel)}`,
  //         config
  //       );
  //       setExportData(response.data)

  //     } else if (service.value === "BEMS") {
  //       response = await axios.get(
  //         `${BemsGraph}/api/GraphbemDepartmentrequest/GetWorkRequestExport/${facilityid}/${year.value}/${month.id}?filterOptions=${JSON.stringify(
  //           filterModel
  //         )}&sortOptions=${JSON.stringify(sortModel)}`,
  //         config
  //       );
  //       setExportData(response.data)


  //     }

  //   } catch (error) {
  //     console.error("Error fetching data", error);
  //   } finally {
  //     setPageLoading(false)
  //   }
  // };




  const handleDelete = (row) => {
    setRowToDelete(row);
    setDeleteDialogOpen(true);

  };

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
  };

  const confirmDelete = async () => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (!rowToDelete || !rowToDelete.id) {
        console.error("Row to delete or its id is undefined");
        return;
      }

      let response;

      if (rowToDelete.service === "FEMS") {
        response = await axios.delete(
          `${FemsGraph}/api/femdepartmentworkrequestheaders/${rowToDelete.id}`,
          config
        );
      } else if (rowToDelete.service === "BEMS") {
        response = await axios.delete(
          `${BemsGraph}/api/bemdepartmentworkrequestheaders/${rowToDelete.id}`,
          config
        );
      }

      if (response.status === 204) {
        setSuccessDialogOpen(true);
      }

      const updatedRows = rows.filter((row) => row.id !== rowToDelete.id);
      setRows(updatedRows);
    } catch (error) {
      console.error("Error deleting user department:", error); // Log the full error object
      if (error.response) {
        console.error("Error response data:", error.response.data); // Log the error response data
        console.error("Error response status:", error.response.status); // Log the error response status
      }
      if (error.response && error.response.status === 400) {
        setErrorMessage(
          "Record cannot be deleted as it is referred in another record."
        );
      } else {
        setErrorMessage(
          "An error occurred while deleting the Department Work Request. Please try again."
        );
      }
    } finally {
      setDeleteDialogOpen(false);
      setRowToDelete(null);
     // fetchUserDepartments();
    }
  };

  const handleRefresh = () => {
    fetchUserDepartments();

    // Set the current year and current month when service changes
    const currentYearValue = { label: currentYear.toString(), value: currentYear.toString() };
    const currentMonthIndex = new Date().getMonth();
    const currentMonthValue = allMonths[currentMonthIndex];

    setYear(currentYearValue);
    setMonthsOptions([...allMonths.slice(0, currentMonthIndex + 1)]); // Up to current month for the current year
    setMonth(currentMonthValue); // Set default to current month
  };


  // DeptUser: same check as User Department Dashboard - completed work orders must be verified
  // before a new work request can be raised. Other roles go straight to the create page.
  const handleCreateUserDepartment = async () => {
    if (roleName !== "DeptUser") {
      navigate("register");
      return;
    }
    setPageLoading(true);
    try {
      const token = getAuthToken("id_token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const departmentid = 1;
      const userid = localStorage.getItem("UserId");
      const [responseFEMS, responseBEMS] = await Promise.all([
        axios.get(`${FemsGraph}/api/Graphfemworkorder/GetUnscheduledVerificationWithin24HoursCount/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`, config),
        axios.get(`${BemsGraph}/api/Graphbemworkorder/GetUnscheduledVerificationWithin24HoursCount/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`, config),
      ]);
      const totalOverdue = (responseFEMS?.data?.overdueOrUnverifiedCount ?? 0) + (responseBEMS?.data?.overdueOrUnverifiedCount ?? 0);
      if (totalOverdue === 0) {
        navigate("register");
      } else {
        setVerificationDialogOpen(true);
      }
    } catch (error) {
      console.error("Error fetching work order verification counts:", error);
    } finally {
      setPageLoading(false);
    }
  };

  const handleEdit = (rowData) => {
    navigate("register", {
      state: {
        ...rowData,
        isEditMode: true,
        assetno: { label: rowData.assetno, value: rowData.assetId },
        categoryId: { label: rowData.categoryName, value: rowData.categoryId },
        typeId: { label: rowData.type, value: rowData.typeId },
      },
    });
  };

  const handleView = (rowData) => {
    navigate("register", {
      state: {
        ...rowData,
        isViewMode: true,
        assetno: { label: rowData.assetno, value: rowData.assetId },
        categoryId: { label: rowData.categoryName, value: rowData.categoryId },
        typeId: { label: rowData.type, value: rowData.typeId },
      },
    });
  };

  return (
    <>
      <PageLoader open={pageLoading} />
      <PageTitle title={"Department Work Request"} />

      <DefaultCard>
        <Stack
          mb={1}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <SectionTitle title={"Department Work Request List"} />
          <Stack direction={"row"} alignItems={"center"} gap={1}>

            <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 150 }}
              label={"Year"}
              options={yearsOptions}
              value={year}
              onChange={handleYearChange}
              placeholder={"Select Year"}
              disableClearable={true}
              highlight={true}
            />
            <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 160 }}
              label={"Month"}
              options={monthsOptions}
              value={month}
              onChange={handleMonthChange}
              placeholder={"Select Month"}
              disableClearable={true}
              disabled={!year}
              highlight={true}
            />
            {/* <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 150 }}
              label={"Service"}
              options={serviceOptions}
              value={service}
              onChange={handleServiceChange}
              placeholder={"Select Service"}
              highlight={true}
              disableClearable={true}
            /> */}
            {(access?.canCreate||deptAccess) && <CreateNewButton onClick={handleCreateUserDepartment} />}
            <RefreshExportButtons
              pagination={false}
              exportFunction={() => { }}
              exportData={rows}
              refData={gridApi}
              handleRefresh={handleRefresh}
              title={`Department Work Request`}
            />
          </Stack>
        </Stack>
        <CustomAgGrid
          rows={rows}
          columns={columns}
          handleEdit={(access?.canEdit||deptAccess)  && localStorage.getItem("roleName") !== "DeptUser" &&handleEdit}
          handleDelete={(access?.canDelete||deptAccess) &&handleDelete}
          handleView={(access?.canView||deptAccess) &&handleView}
          ref={gridApi}
          setGridApi={setGridApi}
          isLoading={isLoading}
          pagination={true}
        // setFilterModel={setFilterModel}
        // setSortModel={setSortModel}
        // totalCount={rowCount}
        // pageIndex={pageIndex}
        // pageSize={pageSize}
        // setPageIndex={setPageIndex}
        // setPageSize={setPageSize}
        />
      </DefaultCard>

      <CustomDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDelete}
        content="Are you sure you want to delete?"
        cancelBtn="No"
        confirmBtn={"Yes"}
      />
      <CustomDialog
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
        content="Record deleted successfully."
        confirmBtn="Ok"
        onConfirm={handleSuccessDialogClose}
      />
      <CustomDialog
        open={!!errorMessage}
        onClose={() => setErrorMessage("")}
        onConfirm={() => setErrorMessage("")}
        title="Warning!"
        content={errorMessage}
        cancelBtn="Cancel"
        confirmBtn={"Ok"}
      />
      <Dialog
        open={verificationDialogOpen}
        onClose={() => setVerificationDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Verification Required</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please verify Completed Work order before Requesting new Work request
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setVerificationDialogOpen(false)} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <CloseButton />
    </>
  );
};

export default Departmentworkrequestlist;
